import { Component, OnInit, ViewChild, TemplateRef,AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DateTime } from '../../dateTime';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from '../services/report.service';
import { environment } from '../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import * as moment from 'moment';
class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
@Component({
  selector: 'app-statement',
  templateUrl: './statement.component.html',
  styleUrls: ['./statement.component.scss']
})
export class StatementComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('bets', {static: false}) public privacyPopup: TemplateRef<any>;
  modalRef: BsModalRef;
  userDetails: any;
  pageSize: number = 51;
  moment: any = moment;
  data: any;
  selections: any;
  statementsLength: any;
  statementsDataSource: any;
  statementsTotalItems: any;
  statementsPageIndex: number;
  timeStatement: Date;
  dateStatement: Date;
  endDateStatement: Date;
  endTimeStatement: Date;
  endTime: any;
  dataSource: any;
  openBetsLength: any;
  MatchList: any;
  searchMatch: any;
  layData: any = [];
  backData: any = [];
  betList: boolean;
  public Base_Url = environment['adminServerUrl'];
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  public token = localStorage.getItem('userAccessToken');
  reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ` + this.token
  });
  router: any;
  settledBetData: any;
  totalItems: any;
  currentPage: any;
  callType: number =1;

  showEndDateInputError: boolean;
  showStartDateInputError: boolean

  constructor(private http: HttpClient, private reportService: ReportService, private modalService : BsModalService,
    private cdRef: ChangeDetectorRef, private toastr: ToastrService, ) { }

  // date time picker
  @ViewChild('popoverRef') private _popoverRef: PopoverDirective;
  @ViewChild('startpopoverRef') private _startpopoverRef: PopoverDirective;
  @ViewChild('endpopoverRef') private _endpopoverRef: PopoverDirective;
  time: Date;
  date: Date;
  isDateVisible: boolean = true;
  isMeridian: boolean = false;
  dateTime = new Date();
  statementStartDate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
  statementEndDate = new Date()
  statementType: any;
  todayDateTime=new Date();

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.statementStartDate.setHours(0, 0, 0, 0);
    this.statementEndDate.setHours(23, 59, 59)
    const that = this;
   
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      searching: true,
      processing: false,
      ordering:false,
      lengthMenu: [10,15,20,25,30,50,100],
      ajax: (dataTablesParameters1: any, callback) => {
        let dataTablesParameters = {
          limit: dataTablesParameters1.length,
          page: (dataTablesParameters1.start / dataTablesParameters1.length) + 1,
          "statement_type": this.statementType,
          "user_id": this.userDetails.user_id,
          "from_date": this.statementStartDate.toISOString(),
          "to_date": this.statementEndDate.toISOString()
        }
        if (dataTablesParameters.statement_type == undefined || dataTablesParameters.statement_type == null) {
          delete dataTablesParameters.statement_type;
        }
        if(this.callType != 1){
          
        that.http.post<DataTablesResponse>(this.Base_Url + 'account/statements', dataTablesParameters, { headers: this.reqHeader })
          .subscribe(resp => {
            if (resp["status"]) {
              this.statementsLength = resp.data[0].data.length
              this.statementsDataSource = resp.data[0].data;
              for (let i = 0; i < this.statementsDataSource.length; i++) {
                this.statementsDataSource[i].updateDateTime = moment(this.statementsDataSource[i].date).utcOffset("+5:30").format('DD-MM-YYYY HH:mm:ss');
                if (this.statementsDataSource[i].credit_debit >= 0) {
                  this.statementsDataSource[i].credit = this.statementsDataSource[i].credit_debit
                  this.statementsDataSource[i].debit = (0)
                } else {
                  this.statementsDataSource[i].credit = (0)
                  this.statementsDataSource[i].debit = -(this.statementsDataSource[i].credit_debit)
                }
              }
              if (resp.data[0].metadata.length != 0) {
                callback({
                  recordsTotal: resp.data[0].metadata[0].total,
                  recordsFiltered: resp.data[0].metadata[0].total,
                  data: this.statementsDataSource
                });
              } else {
                this.statementsDataSource = []
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: this.statementsDataSource
                });
              }
              // callback({
              //   recordsTotal: this.statementsDataSource.length,
              //   recordsFiltered: this.statementsDataSource.length,
              //   data: this.statementsDataSource
              // });

            } else {
              this.toastr.error(resp["msg"], '', {
                positionClass: 'toast-top-center',
                timeOut: 5000
              });
              this.statementsDataSource = []
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: this.statementsDataSource
              });
            }


          });
        }
      },
      columns: [
        {
          title: 'Date',
          data: 'updateDateTime',
          width:'150'
        },
        {
          title: 'Sr no',
          data: '_id'
        },

        {
          title: 'Credit',
          data: 'credit',
          "render": function (data, type, row) {
            var content = ''
            if(row.credit >= 0){
            content = content + '<span class="float-right text-success">' + (row.credit == 0 ? '(0)' : (row.credit).toFixed(2)) + '</span>';
            return content;
          }else{
            content = content + '<span class="float-right text-danger">' + (row.credit == 0 ? '(0)' : (row.credit).toFixed(2)) + '</span>';
            return content;
          }
          },
        },
        {
          title: 'Debit',
          data: 'debit',
          "render": function (data, type, row) {
            var content = ''
            if(row.debit >= 0){
              content = content + '<span class="float-right text-success" style="color:red !important;">' + (row.debit == 0 ? '(0)' : -(row.debit).toFixed(2)) + '</span>';
            return content;
          }else{
            content = content + '<span class="float-right text-danger" style="color:red !important;">' + (row.debit == 0 ? '(0)' : -(row.debit).toFixed(2)) + '</span>';
            return content;
          }
          },
        },
        {
          title: 'Balance',
          data: 'balance',
          "render": function (data, type, row) {
            var content = ''
            if(row.balance >= 0){
            content = content + '<span class="float-right text-success">' + (row.balance).toFixed(2) + '</span>';
            return content;
          }else{
            content = content + '<span class="float-right text-danger">' + (row.balance).toFixed(2) + '</span>';
            return content;
          }
          },
        },
        {
          title: 'Remark',
          data: 'description',
          width:'400',
          "render": function (data, type, row) {
            var content = ''
            content = content + '<span>' + (row.description)+ '</span>';
            return content;
          },
        },
      ],
    //   rowCallback: (row: Node, data: any[] | object, dataIndex: number) => {
    //     row.childNodes[1].textContent = String(dataIndex + 1);
    //  },
      rowCallback :(row: Node, data: any[] | Object, dataIndex: number) => {
        row.childNodes[1].textContent = String(dataIndex + 1);
        const self = this;
          $('td', row).off('click');
          $('td', row).on('click',()=> {
            this.routePath(data);
          });
          return row; 
     },
      // rowCallback :(row: Node, data: any[] | Object, index: number) => {
      //   const self = this;
      //   $('td', row).off('click');
      //   $('td', row).on('click',()=> {
      //     this.userBet(data);
      //   });
      //   return row; 
      // }

    };
    if (this.dateTime) {
      this.time = this.date = this.dateTime;
      return;
    }
    this.date = this.time = new Date(); if (this.statementStartDate) {
      this.time = this.date = this.statementStartDate;
      return;
    }
    if (this.statementEndDate) {
      this.time = this.date = this.statementEndDate;
      return;
    }

  }

  dateSelectionDone() {
    this.isDateVisible = false;
  }
  updateDateStatement() {
    if (this.dateStatement) {
      this.statementStartDate = DateTime.getDateTime(this.dateStatement, this.timeStatement);
    }
    if (!this.timeStatement) {
      this.timeStatement = this.dateStatement;
    }
  }
  updateEndDateStatement() {
    if (this.endDateStatement) {
      this.statementEndDate = DateTime.getDateTime(this.endDateStatement, this.endTimeStatement);
    }
    if (!this.endTimeStatement) {
      this.endTimeStatement = this.endDateStatement;
    }
  }
  updateTimeStatement() {
    if (this.timeStatement) {
      this.statementStartDate = DateTime.getDateTime(this.dateStatement, this.timeStatement);
    }
  }
  updateEndTimeStatement() {
    if (this.endTime) {
      this.statementEndDate = DateTime.getDateTime(this.endDateStatement, this.endTimeStatement);
    }
  }
  updateDate() {

    if (this.date) {
      this.dateTime = DateTime.getDateTime(this.date, this.time);
    }
    if (!this.time) {
      this.time = this.date;
    }
  }

  updateTime() {
    if (this.time) {
      this.dateTime = DateTime.getDateTime(this.date, this.time);
    }
  }

  showDate() {
    this.isDateVisible = true;
  }

  showTime() {
    this.isDateVisible = false;
  }

  close() {
    this._popoverRef.hide();
  }

  closeEndDatepicker() {
    this._endpopoverRef.hide()
  }

  now() {
    this.dateTime = DateTime.now(this.date);
    this.time = this.dateTime;
  }

  today(from) {

     if(from === "start") this.statementStartDate = DateTime.now(this.date);
     if(from === "end") this.statementEndDate = DateTime.now(this.date);
  }
  clear(from) {
    //https://valor-software.com/ngx-bootstrap/#/timepicker#dynamic
    //Check component DemoTimepickerDynamicComponent  -> clear() method;  void 0 evaluates to undefined
    this.time = void 0;
    this.date = void 0;
    this.dateTime = void 0;
    if(from === "start"){
      this.dateStatement = void 0;
      this.timeStatement = void 0;
      this.statementStartDate=null;
     
    }
    if(from === "end"){
      this.endDateStatement = void 0;
      this.endTimeStatement = void 0;
      this.statementEndDate=null;
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  routePath(list) {
    if (list.statement_type == 4 || list.statement_type == 2) {
      this.goToViewBets(list);
      this.openModalBets(this.privacyPopup);
    }
  }

  onChangeDateInput(event:any, from){
    let date= Date.parse(event.target.value)
    if(from == 'start'){
      if(date){
        this.showStartDateInputError=false
      }else{
        this.showStartDateInputError=true
      }
    }else if(from == 'end'){
      if(date){
        this.showEndDateInputError=false
      }else{
        this.showEndDateInputError=true
      }
    }
    
  }
  goToViewBets(data) {
    let param = {
      "match_id": data.match_id,
      "search": {
      }
    }
    if (data.type  == 1) {
      param.search['market_id'] = data.event_id
    } else {
      param.search['fancy_id'] = data.event_id
    }
    if (param.search == undefined) {
      delete param.search
    }
    this.reportService.settleBets(param).subscribe((resp) => {
      if (resp["status"]) {
          if ((resp.data[0].data).length != 0) {
            this.settledBetData = resp.data[0].data;
            for (let i = 0; i < this.settledBetData.length; i++) {
              if (this.settledBetData[i].is_fancy == 0) {
                this.settledBetData[i].updateSelection = this.settledBetData[i].selection_name;
                this.settledBetData[i].updateOdds = this.settledBetData[i].odds;
                this.settledBetData[i].updatePl = this.settledBetData[i].chips
                if (this.settledBetData[i].is_back == 1) {
                  this.settledBetData[i].updateType = 'Back'
                } else {
                  this.settledBetData[i].updateType = 'Lay'
                }
              } else {
                this.settledBetData[i].updateSelection = this.settledBetData[i].odds;
                this.settledBetData[i].updateOdds = this.settledBetData[i].odds + '/' + this.settledBetData[i].size;
                if (this.settledBetData[i].is_back == 1) {
                  this.settledBetData[i].updateType = 'Yes'
                  if (this.settledBetData[i].odds < this.settledBetData[i].winner_name) {
                    this.settledBetData[i].updatePl = this.settledBetData[i].p_l
                  } else {
                    this.settledBetData[i].updatePl = this.settledBetData[i].liability
                  }
                } else {
                  this.settledBetData[i].updateType = 'No'
                  if (this.settledBetData[i].odds > this.settledBetData[i].winner_name) {
                    this.settledBetData[i].updatePl = this.settledBetData[i].chips
                  } else {
                    this.settledBetData[i].updatePl = this.settledBetData[i].p_l
                  }
                }
              }
            }
          } else {
            this.settledBetData = []
          }
      } else {
        this.toastr.error(resp["msg"], '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
          this.settledBetData = [];
        }
    })
  }
  openModalBets(bets: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      bets,
      Object.assign({}, { class: 'modal-full' })
    );
  }
  submit(){
    this.callType = 0;
    this.rerender()
  }

  getToday(){
    return new Date().toISOString().split('T')[0]
  }


 
  
}
